export class Numero {
    serie?:string;
    clasedoc?:string;
    ultimo?:number;
    idnumero?:number;
}
